<template>
  <div id="ui-kit-video-header-section">
    <div v-if="videoLoaded" id="video-hero" :style="{ backgroundImage: `url(${video.thumbnail})` }">
      <div id="ui-kit-video" class="container">

        <div class="video-box" id="v-box">

          <video id="myVideo" @play="playVideo()" @pause="pauseVideo()" ref="video" width="100%" preload="none"
            x-webkit-airplay="allow" :poster="video.thumbnail" playsinline controls>
            <source :src="video.videoSrc" type="video/mp4">
          </video>
        </div>

        <div class="video-title">
          <h1>
            <span> {{ video.title }}
            </span>
          </h1>
          <span class="video-subtitle"> {{ video.views | formatEngagementMetric }} views |
            {{
              video.firstPublicationDate | relativePublicationDate }}

          </span>
          <div class="b-video-description">
            {{ video.description }}


          </div>

          <div class="d-none d-lg-flex">

            <v-btn large v-if="!videoPlaying" @click="playVideo()" class="p-4 rounded-xxl mt-4 black--text"
              color="accent">
              <v-icon dark>
                mdi-play-circle-outline
              </v-icon>
              Play
            </v-btn>

            <v-btn large v-if="videoPlaying" @click="pauseVideo()" class="rounded-xxl mt-4 black--text" color="accent">
              <v-icon dark>
                mdi-pause
              </v-icon>
              Pause

            </v-btn>

          </div>



          <v-col cols="12" class="py-2 ml-0 pl-0 mt-4">


            <v-btn class="mr-2" color="grey darken-4" @click="likeVideo()">

              <v-icon :color="thumbsUpColor" class="mr-1">mdi-thumb-up</v-icon>
              <span :style="{ color: thumbsUpColor }">{{ video.likes | formatEngagementMetric }} </span>

            </v-btn>

            <v-btn dark class="mr-2" color="grey darken-4" @click="dislikeVideo()">
              <v-icon :color="thumbsDownColor" class="mr-1">mdi-thumb-down</v-icon>
              <span :style="{ color: thumbsDownColor }">{{ video.dislikes | formatEngagementMetric }} </span>

            </v-btn>




            <v-btn dark class="mr-2" color="grey darken-4" @click="share()">
              <v-icon class="mr-1">mdi-share</v-icon>
              <span class=""> {{ video.shares | formatEngagementMetric }} </span>

            </v-btn>


          </v-col>

        </div>
      </div>
    </div>

    <div :class="{ 'container': isDesktop }">

      <v-card class="rounded-0" v-if="videoLoaded">
        <v-tabs center-active background-color="accent" class="elevation-0">
          <v-tabs-slider color="teal"></v-tabs-slider>

          <v-tab class="elevation-0">Transcript</v-tab>
          <v-tab @click="viewedRecommendedVideos()">You May Also Like</v-tab>

          <v-tab-item class="elevation-0 ">
            <div v-if="videoLoaded">
              <div v-if="video.transcript.length > 0" class="mt-4 pl-4 pr-4">
                <PrismicRichText :field="video.transcript" />
              </div>
            </div>
            <div v-else class="mt-4 pl-4 pr-4">
              Transcript is not available yet.
            </div>

          </v-tab-item>
          <v-tab-item border="false">

            <div class="cross-sells container" v-if="recommendedVideosLoaded">

              <div class="card" v-if="item.objectID !== video.objectID" v-for="item in videos"
                @click="videoClicked(item)">


                <div class="image">
                  <img :src="item.thumbnail" :alt="item.title" class="hit-image" />

                </div>
                <div class="user">

                  <img class="avatar" width="40" height="40" :src="item.author.avatar">
                  <div class="b-info">
                    <div class="e-title">{{ item.author.name }}</div>
                    <div class="e-date">{{ item.firstPublicationDate | relativePublicationDate }} | {{ item.duration }}
                      min watch time </div>
                  </div>
                </div>
                <div class="title">
                  <span> {{ item.title }}</span>
                </div>
                <div class="description">
                  <span> {{ item.description }}</span>
                </div>
                <div class="love">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.27454 9.36932V21.3693H1.27454V9.36932H5.27454ZM9.27454 21.3693C8.7441 21.3693 8.2354 21.1586 7.86032 20.7835C7.48525 20.4085 7.27454 19.8998 7.27454 19.3693V9.36932C7.27454 8.81932 7.49454 8.31932 7.86454 7.95932L14.4445 1.36932L15.5045 2.42932C15.7745 2.69932 15.9445 3.06932 15.9445 3.47932L15.9145 3.79932L14.9645 8.36932H21.2745C22.3845 8.36932 23.2745 9.26932 23.2745 10.3693V12.3693C23.2745 12.6293 23.2245 12.8693 23.1345 13.0993L20.1145 20.1493C19.8145 20.8693 19.1045 21.3693 18.2745 21.3693H9.27454ZM9.27454 19.3693H18.3045L21.2745 12.3693V10.3693H12.4845L13.6145 5.04932L9.27454 9.39932V19.3693Z"
                      fill="black" />
                  </svg>
                  <span>{{ item.likes }}</span>
                </div>
                <div class="category">
                  <div v-for="category in item.categories">
                    <button class="button">{{ category }}</button>

                  </div>
                </div>
                <button class="action">Watch Video</button>
              </div>
            </div>

          </v-tab-item>


        </v-tabs>
      </v-card>

    </div>

  </div>
</template>

<style>
.action-btn.v-btn--active::before {
  opacity: 0;
}

.action-btn:focus::before {
  opacity: 0 !important;
}

.v-tabs-bar.accent .v-tab {
  color: black;
}

#ui-kit-video-header-section {
  /* background:linear-gradient(to bottom, #0DD7B5, #01AC9B); */
  margin: 0;
  padding: 0px;
  /* margin-top: 16px; */
  margin-bottom: 16px;
  margin-top: 50px;

}

#myVideo {
  width: 100%;
  /* Set width to 100% */
  height: auto;
  /* Allow height to adjust proportionally */
}

#video-hero {
  /* background: linear-gradient(to bottom, #0DD7B5, #01AC9B); */
  /* background: linear-gradient(to bottom, black, rgb(56, 53, 53)); */
  /* background: url('https://images.prismic.io/measure-academy/Zf2gKscYqOFdyCGY_maxresdefault_rmirv7.jpg?auto=format%2Ccompress&rect=0%2C0%2C1280%2C720&w=1024&h=576'); */
  box-shadow: inset 1500px 0px 200px 10px rgba(0, 0, 0, 0.9);
  background-size: cover;
  -webkit-filter: brightness(100%);
  /* height: 425px; */
  /* background: linear-gradient(to right, #030303, #1e2121, #2f3634, #0DD7B5); */
  /* background-color: #55efc4; */
  /* background-image: linear-gradient(315deg, #55efc4 0%, #000000 74%); */
  z-index: -1;
}







#ui-kit-video {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 48px;
  padding-bottom: 48px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* background: linear-gradient(to bottom, #0DD7B5, #01AC9B); */
  width: 100%;
  height: auto;
}


.video-box {
  position: relative;
  height: 100%;
  order: 2;
  margin-left: auto;
  max-width: 45%;
  margin-bottom: 15px;
  border-radius: 5px;
  box-shadow: 0 20px 25px -5px #000, 0 8px 10px -6px #000;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  z-index: 1000;
}

@media only screen and (min-width: 1024px) {
  .video-box {
    max-width: 63%;
  }

  .video-title {
    max-width: 34%;
  }
}

.b-video-description {
  color: white;
  margin-top: 12px;
  z-index: 10;
}



video {
  display: block;
  border-radius: 5px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 5px;
  overflow: hidden;
  height: auto;
  width: 100%;
  object-fit: scale-down;
}

.video-title {
  width: 45%;
  color: white;
}

.video-subtitle {
  filter: brightness(0.8)
}

@media (max-width: 899px) {

  #ui-kit-video {
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 0px;
  }

  .video-title {
    width: 100%;
    order: 2;
    padding: 12px;
  }

  .video-box {
    order: 1;
    margin: 0;
    max-width: 100%;
    border-radius: 0px;
  }

  video {
    min-height: auto;
    height: auto;
    border-radius: 0px;
  }

  div:where(.swal2-container) .swal2-html-container {
    margin: 0 !important;
  }

  .swal2-popup {
    padding: 24px !important;
  }

}


.button {
  background-color: black;
  color: white;

}



.action-bar {
  margin-top: 16px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 18px;
}

svg:hover {
  cursor: pointer;
}

.cross-sells-header {
  padding-left: 24px;
  padding-top: 48px;
  padding-bottom: 24px;
}

.cross-sells {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 24px;
  gap: 24px;
  justify-content: space-between;

}



.card {
  --primary: black;
  --secondary: #0DD7B5;
  --dark-green: #1A7D6D;
  --blue-500: #00a3fe;
  width: 30%;
  border-radius: 5px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);


  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;

  padding: 0;
  height: auto;
  background-color: whitesmoke;

  border-radius: 0.5rem;
}

.card .user {
  background: #f7f8f9;
  border-radius: 9px;
  height: 60px;
  padding: 9px 12px;
  text-align: left;
  display: flex;
}

.card .avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid whitesmoke;
  margin-right: 12px;
}

.card .b-info {
  flex: 1;
}

.card .e-title {
  font-size: 14px;
  font-weight: 700;
}

.card .e-date {
  font-size: 13px;
  color: grey;
}



.card .rectangle {
  position: absolute;

  width: 0.925rem;
  aspect-ratio: 1 / 1;
  background-color: white;

  opacity: 0;
  box-shadow: 0rem 0rem 0rem 0.175rem black;
}

/* .card:hover .rectangle {
    opacity: 1;
  } */

/* .card .rectangle.left-top {
    top: -0.25rem;
    left: -0.25rem;
  } */
/* .card .rectangle.right-top {
    top: -0.25rem;
    right: -0.25rem;
  }
  .card .rectangle.left-bottom {
    bottom: -0.25rem;
    left: -0.25rem;
  } */
/* .card .rectangle.right-bottom {
    bottom: -0.25rem;
    right: -0.25rem;
  } */

.card .image {
  display: block;
  position: relative;
  justify-content: center;
  align-items: center;

  width: 100%;

  /* border-radius: 0.25rem; */
}

.card .image .svg {
  width: 2.5rem;
  fill: black;
}

.card .title {
  position: relative;

  font-size: 1.25rem;
  color: white;
  font-weight: bold;
}

.card .love {
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: 0.375rem;

  font-size: 1rem;
  font-weight: bold;
  color: black;
}

.card .title {
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  gap: 0.375rem;

  font-size: 1rem;
  font-weight: bold;
  color: black;
}

.card .description {
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  gap: 0.375rem;

  font-size: 0.8rem;
  font-weight: normal;
  color: black;
}

.card .love .svg {
  width: 1.25rem;
  fill: red;
}

.card .category {
  padding-left: 12px;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.card .category .button {

  /* padding-left: 12px; */
  padding: 0.25rem 0.5rem;
  background-color: #d2dcd5;

  font-size: 0.7rem;
  color: black;

  border: 2px solid transparent;
  border-radius: 9999px;
  transition: all 0.3s ease-in-out;
}

.card .category .button:hover {}

.card .action {
  padding-block: 0.375rem;
  margin-top: 0.75rem;
  background-color: var(--secondary);

  font-size: 0.75rem;
  font-weight: 700;
  color: black;

  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 12px;
}

.card .action:hover {
  cursor: pointer;
  background-color: black;
  color: white;
}

@media (max-width: 899px) {
  .cross-sells {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-left: 0px;
  }

  .cross-sells-header {
    padding-left: 12px;
  }

  .card {
    width: 100%;
  }
}
</style>


<script>
import algoliasearch from 'algoliasearch';
import moment from 'moment';
import store from '@/store/index';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import '../swal.css';

import '../Theme.css';
import '../App.css';
import '../App.mobile.css';




export default {

  filters: {
    relativePublicationDate: function (date) {
      return moment(date).fromNow();
    },
    formatEngagementMetric: function (likes) {

      if (isNaN(likes)) {
        return 0;
      }

      let formatted = Math.abs(likes) > 999 ? Math.sign(likes) * ((Math.abs(likes) / 1000).toFixed(1)) + 'k' : Math.sign(likes) * Math.abs(likes)
      return formatted;
    }
  },

  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_KEY
      ),
      pageTitle: 'Moasure Video Tutorials',
      pageImage: '',
      isDesktop: false,
      loader: null,
      index: null,
      video: null,
      videos: [],
      videoLoaded: false,
      recommendedVideosLoaded: false,
      videoLiked: false,
      videoDisliked: false,
      thumbsUpColor: 'white',
      thumbsDownColor: 'white',
      transcriptColor: 'white',
      shareColor: 'white',
      videoPlaying: false,
      timer: null,
      totalSecondsPlayed: 0,
      viewStored: false,
      userIP: null

    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
      description: this.pageDescription,
      meta: [
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.pageTitle
        },
        {
          vmid: 'og:type',
          property: 'og:type',
          content: 'video'
        },
        {
          vmid: 'og:image',
          property: 'og:image', // Assuming g:title is a custom meta tag you wish to use
          content: this.pageImage
        }
      ]
    };
  },
  watch: {
    totalSecondsPlayed(newValue, oldValue) {
      // console.log(this.totalSecondsPlayed + ' seconds played')
      if (newValue >= 30 && !this.viewStored) {
        // console.log('Storing View')

        this.viewStored = true;
        this.storeView(this.video.id);
      }

    }
  },
  beforeRouteUpdate(to, from, next) {

    this.videoLoaded = false;
    this.videoPlaying = true;
    clearInterval(this.timer);
    this.totalSecondsPlayed = false;


    this.index.getObjects([to.params.id])
      .then(obj => {
        this.video = obj.results[0];
        this.videoLoaded = true;
        this.recommendVideos(obj.results[0]);
        this.getInteractions(obj.results[0].id);

      });
    window.scrollTo(0, 0);
    next();
  },
  mounted() {

    window.analytics.page('Video');
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    this.isDesktop = !this.$vuetify.breakpoint.xs;

    this.id = this.$route.params.id;
    this.index = this.searchClient.initIndex('academy_videos');

    this.index.getObjects([this.$route.params.id])
      .then(obj => {
        this.video = obj.results[0];
        this.videoLoaded = true;
        this.pageTitle = 'Moasure Video Tutorials | ' + obj.results[0].title;
        this.pageDescription = obj.results[0].description;
        this.pageImage = obj.results[0].thumbnail;
        this.recommendVideos(obj.results[0]);
        this.getInteractions(obj.results[0].id);

      });

    this.getUserIP();







  },

  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },

  computed: {
    richTextHtml() {
      return this.$prismic.asHtml(this.video.transcript, this.linkResolver, this.htmlSerializer);
    },
    liked() {
      return this.$store.state.videos.liked;
    },
    disliked() {
      return this.$store.state.videos.disliked;
    }
  },


  methods: {
    getUserIP() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(response => {
          this.userIP = response.ip;


          window.analytics.identify(response.ip, {

          });
        });
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.totalSecondsPlayed++;
      }, 1000);
    },
    pauseTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    handleBeforeUnload(event) {

      //   Swal.fire({
      //     title: "You have watched",
      //     html: this.totalSecondsPlayed + ' ' + 'seconds',
      //     width: 600,
      //     padding: "3em",
      //     color: "black",
      //     confirmButtonColor: "black",

      //     backdrop: `
      //   rgba(0,0,123,0.4)
      //   url("/images/nyan-cat.gif")
      //   left top
      //   no-repeat
      // `
      //   });
    },
    getInteractions(id) {
      this.$store
        .dispatch('videos/GET_INTERACTIONS', id)
        .then(response => {
          this.videoLiked = response.data.liked;
          this.thumbsUpColor = (this.videoLiked) ? '#0DD7B5' : 'white';
          this.videoDisliked = response.data.disliked;
          this.thumbsDownColor = (this.videoDisliked) ? '#0DD7B5' : 'white';

        })
        .catch(error => {
          console.log(error)
        });
    },
    storeLike(id) {
      this.$store
        .dispatch('videos/LIKE_VIDEO', id)
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        });
    },
    storeDislike(id) {
      this.$store
        .dispatch('videos/DISLIKE_VIDEO', id)
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        });
    },
    storeShare(id) {
      this.$store
        .dispatch('videos/SHARE_VIDEO', id)
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        });
    },
    storeView(id) {
      this.$store
        .dispatch('videos/VIEW_VIDEO', id)
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        });
    },
    playVideo(type) {
      this.startTimer();
      let video = document.getElementById("myVideo");
      video.play();
      this.videoPlaying = true;
      this.trackPlayedVideo(this.video);


    },
    trackPlayedVideo(video) {

      window.analytics.track('Played Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    pauseVideo() {
      this.pauseTimer();
      let video = document.getElementById("myVideo");
      video.pause();
      this.videoPlaying = false;
      this.trackPausedVideo();
    },
    trackPausedVideo(video) {

      window.analytics.track('Paused Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },

    showTranscript(video) {

      Swal.fire({
        title: "Video Transcript",
        html: (video.transcript) ? this.richTextHtml : 'This video does not yet have a transcript',
        width: 600,
        padding: "3em",
        color: "black",
        confirmButtonColor: "black",

        backdrop: `
        rgba(0,0,123,0.4)
        url("/images/nyan-cat.gif")
        left top
        no-repeat
      `
      });


    },
    share() {
      if (navigator.share) {
        this.storeShare(this.video.id);
        this.video.shares = parseInt(this.video.shares) + 1;
        navigator.share({
          icon: this.video.thumbnail,
          image: this.video.thumbnail,
          title: this.video.title,
          url: this.$route.fullPath,
          text: `Watch this video on Moasure Academy:\n ${this.video.title} \n`
        }).then(() => {

        })
          .catch(console.error);
      } else {

        Swal.fire({
          html: '<b>Share </b> this video with others...',
          padding: "3em",
          color: "black",
          confirmButtonColor: "black",
          confirmButtonText: "Copy Link",
          showCancelButton: true,
          cancelButtonColor: "DarkGrey"
        }).then((result) => {
          if (result.isConfirmed) {
            this.storeShare(this.video.id);
            this.video.shares = parseInt(this.video.shares) + 1;
            navigator.clipboard.writeText(window.location.origin + this.$route.fullPath);
            Swal.fire({
              toast: true,
              position: 'top-end',
              timerProgressBar: true,
              timer: 1500,
              showConfirmButton: false,
              title: "Link copied to clipboard!",
              icon: "success",
            });
          }
        })
      }

      this.trackSharedVideo(this.video);



    },
    recommendVideos(video) {

      this.index.search("Paths")
        .then(obj => {
          this.videos = obj.hits.slice(0, 4);
          this.recommendedVideosLoaded = true;
        });

    },
    likeVideo() {
      this.storeLike(this.video.id)

      if (!this.videoLiked) {
        this.videoLiked = true;
        this.video.likes++;
        this.thumbsUpColor = '#0DD7B5';
        this.trackLikedVideo(this.video);
      } else {
        this.videoLiked = false;
        this.video.likes--;
        this.thumbsUpColor = 'white';
      }

      if (this.videoDisliked) {
        this.videoDisliked = false;
        this.video.dislikes--;
        this.thumbsDownColor = 'white';
      }


    },

    dislikeVideo() {
      this.storeDislike(this.video.id)

      if (!this.videoDisliked) {
        this.videoDisliked = true;
        this.video.dislikes++;
        this.thumbsDownColor = '#0DD7B5';
        this.trackDislikedVideo(this.video);

      } else {
        this.videoDisliked = false;
        this.video.dislikes--;
        this.thumbsDownColor = 'white';
      }

      if (this.videoLiked) {
        this.videoLiked = false;
        this.video.likes--;
        this.thumbsUpColor = 'white';
      }


    },
    videoClicked(video) {
      this.trackOpenedRecommendedVideo(video);
      this.$router.push({ name: 'video', params: { id: video.objectID } });

    },
    trackLikedVideo(video) {

      window.analytics.track('Liked Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    trackDislikedVideo(video) {

      window.analytics.track('Disliked Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    trackSharedVideo(video) {

      window.analytics.track('Shared Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    viewedRecommendedVideos() {
      this.trackViewedRecommendedVideos(this.video);
    },
    trackViewedRecommendedVideos(video) {

      window.analytics.track('Viewed Recommended Videos', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    trackOpenedRecommendedVideo(video) {

      window.analytics.track('Opened Recommended Video', {
        VideoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },



  },
};
</script>
